<template>
<div>
  <!--выбор цвет-->
  <md-field>
    <label>Фильтр цветов</label>
    <md-input v-model="search" ></md-input>
  </md-field>
    <div class="mt-2 text-left" >
    <b-form-group>
      <b-form-checkbox class="mt-2"
                  v-model="selectColorFasade" :value="true" >
       <p class="m-1 text-black siz">Рекомендуемые фасадные цвета</p>
      </b-form-checkbox>
    </b-form-group>
    </div>
  <b-form-select  v-model="color_info" class="item-select mb-2 mt-3 form-select-lg w-100 "
                  @change="$emit('getColor',[color_info])" >
    <template #first>
      <b-form-select-option :value="null" disabled>-- Цвет --</b-form-select-option>
    </template>
    <!-- item.desc === 1 (это для фасадных цветов) -->
    <template v-if="selectColorFasade">
      <b-form-select-option v-for="item in color.data" :key="item.id+'f'" style="font-family: 'Roboto Slab'" v-show="item.name.includes(searchUp) && item.desc === '1'" :value="[item.id, item.name, item.color, item.desc]" >
        {{item.name}}
      </b-form-select-option>
    </template>

    <template v-else>
      <b-form-select-option v-for="item in color.data" :key="item.id" style="font-family: 'Roboto Slab'" v-show="item.name.includes(searchUp)" :value="[item.id, item.name, item.color, item.desc]" >
        {{item.name}}
      </b-form-select-option>
    </template>





<!--    <b-form-select-option  v-for="item in serchArrColor" :key="item.id" :value="[item.id, item.name, item.color]">
      {{item.name}} </b-form-select-option>-->

  </b-form-select>

</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {

  name: "InputSelectColor",
  data() {
    return {
      color_info: null,
      search: '',
      selectColorFasade: false,
    }
  },
  computed: {
    ...mapGetters(['color']),
    searchUp(){
     return this.search.toUpperCase();
    }
  },

  methods: {
    ...mapActions(['loadColors']),
  }
}

</script>

<style scoped>


</style>